/**
 *
 * Asynchronously loads the component for Imp006
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
